import { isValidElement } from 'react';
import { BackgroundImage } from '../backgroundImage';
import styles from './Columns.css';
import type { ColumnsElementProps } from './Columns.type';
import { getColumnsInnerWrapperAttributes, getColumnsRootAttributes } from './utils';

function ColumnsInnerWrapper(props: ColumnsElementProps) {
  const { children } = props;
  return <div {...getColumnsInnerWrapperAttributes(props)}>{children}</div>;
}

export function ColumnsRoot(props: ColumnsElementProps) {
  const { children: _children, ...restProps } = props;
  const { element } = restProps;
  const { backgroundDarken, backgroundImage: elBackgroundImage } = element.attrs || {};

  let bgImage: any;
  if (elBackgroundImage) {
    bgImage = <BackgroundImage src={elBackgroundImage} darken={backgroundDarken} />;
  }

  return (
    <div {...getColumnsRootAttributes(props)}>
      {isValidElement(bgImage) && (
        <div contentEditable={false} className={styles.background}>
          {bgImage}
        </div>
      )}
      {props.children}
    </div>
  );
}

export function ColumnsElement(props: ColumnsElementProps) {
  const { children, ...restProps } = props;

  return (
    <ColumnsRoot {...restProps}>
      <ColumnsInnerWrapper {...restProps}>{children}</ColumnsInnerWrapper>
    </ColumnsRoot>
  );
}
